import "@fontsource-variable/mona-sans";
import "@fontsource-variable/geist-mono";
import "../styles/tokens.css";
import "./site.css";

// Preserve invitations on static preview hosts as well as the production server.
if (location.pathname === "/" && new URLSearchParams(location.search).has("room")) {
  location.replace(`/play${location.search}${location.hash}`);
}
